document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper('.js-swiper', {
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
  });
  
  var circleSwiper = new Swiper('.js-circleSwiper', {
    slidesPerView: 'auto',
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });


  var catSwiper = new Swiper(".mySwiper01", {
    slidesPerView: 1,
    allowTouchMove: false,
    effect: 'fade',
    autoHeight: true,
    breakpoints: {
      600: {
        slidesPerView: 2,
        effect: 'none',

      }
    }
  });
  $('.js-catBtn a').click(function () {
    $('.js-catBtn a').removeClass('is-active')
    $(this).addClass('is-active')
    catSwiper.slideTo($(this).attr('href'))
    return false;
  })

  $('.js-menu-link').each(function () {
    $(this).on('click', function () {
      //$('.toggleBtn').removeClass('is-active');
      // $('.js-menu-link').not(this).next('.questionItem__text').slideUp();
      $(this).children('.toggleBtn').toggleClass('is-active');
      $("+.questionItem__text", this).slideToggle(function(){
        catSwiper.updateAutoHeight();
      });
      return false;
    });
  });
})

